import PropTypes from 'prop-types';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import HubSpotLanguageSelect from 'ui-addon-i18n/components/HubSpotLanguageSelect';
import Loading from '../components/Loading';
import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LanguageEditor = ({
  failed,
  loadingLocaleMapping,
  loadingUserLanguage,
  language,
  handleLanguageChanged,
  isUngatedBetaLanguages
}) => {
  if (loadingUserLanguage) {
    return /*#__PURE__*/_jsx(Loading, {});
  }
  const errorMessage = failed ? /*#__PURE__*/_jsx(NavMarker, {
    name: "LANGUAGE_EDITOR_DATA_ERROR",
    children: I18n.text('userPreferences.errors.failedToLoadLanguageData')
  }) : null;
  return /*#__PURE__*/_jsxs(Form, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "LANGUAGE_EDITOR_DATA_LOADED"
    }), /*#__PURE__*/_jsx(FormControl, {
      "aria-label": "languages",
      label: I18n.text('userPreferences.labels.language'),
      tooltip: I18n.text('userPreferences.help.language'),
      error: !!errorMessage,
      validationMessage: errorMessage,
      paddingBlockStart: "0",
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(HubSpotLanguageSelect, {
        "data-test-id": "language-select",
        disabled: loadingLocaleMapping || failed,
        useBetaLanguages: isUngatedBetaLanguages,
        value: language || 'en',
        onChange: languageProps => handleLanguageChanged(languageProps.language)
      })
    }), loadingLocaleMapping ? /*#__PURE__*/_jsx(Loading, {}) : null]
  });
};
LanguageEditor.propTypes = {
  failed: PropTypes.bool.isRequired,
  isUngatedBetaLanguages: PropTypes.bool.isRequired,
  loadingUserLanguage: PropTypes.bool.isRequired,
  loadingLocaleMapping: PropTypes.bool.isRequired,
  language: PropTypes.string,
  handleLanguageChanged: PropTypes.func.isRequired
};
export default LanguageEditor;